import React, { useEffect, useState } from 'react';
import Heading from 'src/elements/typography/heading';
import { Color, palette } from 'src/styles/colors';

import { StaticHeadlineText, TypedInText, TypedInTextSpacer, WordSliderContainer } from './WordTypeIn.styles';

const WORDS_TO_SWAP = ['memberships', 'courses', 'challenges', 'events'];

interface WordTypeInProps {
  heroMainHeadline: string;
  heroStaticHighlightedText?: string;
  textColor?: Color;
}

const WordTypeIn = ({
  heroMainHeadline,
  heroStaticHighlightedText = null,
  textColor = 'sunshine',
}: WordTypeInProps): JSX.Element => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [highlightedText, setHighlightedText] = useState('');
  const [highlightedTextSubstringIndex, setHighlightedTextSubstringIndex] = useState(0);

  useEffect(() => {
    if (heroStaticHighlightedText) return;

    const activeWord = WORDS_TO_SWAP[currentWordIndex];

    const actionState = (): [string, number] => {
      if (activeWord === highlightedText) {
        return ['active', 2700];
      }
      if (highlightedTextSubstringIndex === 0 || activeWord.indexOf(highlightedText) === 0) {
        return ['typing', 100];
      }
      return ['deleting', 50];
    };

    const [state, delay] = actionState();

    const timeoutId = setTimeout(() => {
      if (state === 'active') {
        setCurrentWordIndex((prev) => (prev + 1) % WORDS_TO_SWAP.length);
        return;
      }
      if (state === 'typing') {
        const nextI = highlightedTextSubstringIndex + 1;
        setHighlightedText(activeWord.substring(0, nextI));
        setHighlightedTextSubstringIndex(nextI);
        return;
      }
      if (state === 'deleting') {
        const nextI = highlightedTextSubstringIndex - 1;
        setHighlightedText(highlightedText.substring(0, nextI));
        setHighlightedTextSubstringIndex(nextI);
      }
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [heroStaticHighlightedText, currentWordIndex, highlightedText, highlightedTextSubstringIndex]);

  return (
    <WordSliderContainer>
      <Heading
        color={palette.white}
        standardSize='5'
        align='center'
        lineHeight='113%'
        sizeSm='2.125rem'
      >
        <StaticHeadlineText>
          {heroMainHeadline}
          <TypedInText textColor={textColor}>
            {heroStaticHighlightedText ?? highlightedText}
            <TypedInTextSpacer />
          </TypedInText>
        </StaticHeadlineText>
      </Heading>
    </WordSliderContainer>
  );
};

export default WordTypeIn;
